import { PropsWithChildren } from 'react';
import Stack from '@mui/material/Stack';
import { colors } from '../../theme';
import { SkilljarHeader } from './SkilljarHeader';
import { SkilljarFooter } from './SkilljarFooter';

export const SkilljarRoot = ({ children }: PropsWithChildren) => {
  return (
    <>
      <SkilljarHeader />
      <Stack flex={1} bgcolor={colors.black}>
        <Stack flex={1}>{children}</Stack>
        <SkilljarFooter />
      </Stack>
    </>
  );
};
